/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Overdue_ReceivableInputs */

const en_case_payment_overdue_receivable = /** @type {(inputs: Case_Payment_Overdue_ReceivableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overdue receivable`)
};

const pt_br2_case_payment_overdue_receivable = /** @type {(inputs: Case_Payment_Overdue_ReceivableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor a receber — atrasado`)
};

/**
* | output |
* | --- |
* | "Overdue receivable" |
*
* @param {Case_Payment_Overdue_ReceivableInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_overdue_receivable = /** @type {((inputs?: Case_Payment_Overdue_ReceivableInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Overdue_ReceivableInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_overdue_receivable(inputs)
	return pt_br2_case_payment_overdue_receivable(inputs)
});